import { render, staticRenderFns } from "./GP4AM_states.vue?vue&type=template&id=04bb9862&scoped=true&"
import script from "./GP4AM_states.vue?vue&type=script&lang=js&"
export * from "./GP4AM_states.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bb9862",
  null
  
)

export default component.exports